import React, { useContext, useEffect, useState } from 'react';
import Application from '../../../StateContext/Application';
import { Cancel32, submit } from '../../../../../public/LoginImages/importimages';

const BinManagement = () => {
    const statecalls = useContext(Application);
    const { getBindata, BinManagement } = statecalls;

    const [Bin, setBin] = useState([]);
    const [data, setData] = useState([]);
    const [formData, setFormData] = useState({
        BinSeries: '',
        Binnumber: '',
    });

    const getdata = async () => {
        const response = await BinManagement("get", { BinSeries: formData.BinSeries });
        if (response && Array.isArray(response)) {
            setData(response);
        } else {
            setData([]);
        }
    };

    const getBin = async () => {
        const binData = await getBindata();
        if (Array.isArray(binData)) {
            setBin(binData);
        } else {
            setBin([]);
        }
    };

    useEffect(() => {
        getBin();
    }, []);

    useEffect(() => {
        if (formData.BinSeries) {
            getdata();
        } else {
            setData([]);
        }
    }, [formData.BinSeries]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const Submit = async (e) => {
        e.preventDefault();
        try {
            const response = await BinManagement('insert', formData);
            alert(response.message);
            setFormData({ BinSeries: '', Binnumber: '' });
            if (formData.BinSeries) getdata(); // Refresh table
        } catch (error) {
            console.error('Error during bin addition:', error);
            alert('An error occurred while adding the bin.');
        }
    };

    return (
        <div style={{ maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ backgroundColor: '#f4f7fe', backgroundSize: 'cover', alignSelf: 'center', display: 'grid', justifyContent: "center", padding: '1rem', position: "relative", backdropFilter: 'blur(10px)' }}>

                <div style={{ display: "grid", justifyContent: "center" }}>
                    <form onSubmit={Submit} style={{ display: 'grid', justifyContent: 'center', backgroundColor: 'rgb(255,255,255,0.8)', borderRadius: '20px', width: '56rem' }}>
                        <h3 style={{ display: 'flex', justifyContent: 'center', background: 'linear-gradient(to bottom, #3b409e, #0067ab, #0f79ba, #0098d5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: '700', }}>Budget Estimation</h3>
                        <div style={{ display: 'grid', justifyContent: 'center', padding: '20px',gap:'20px' }}>
                            <div style={{ display: 'grid', width: '45rem', justifyContent: 'center', padding: '2rem', background: 'linear-gradient(to Right, #CCEAF7, #CFE4F1, #CCE1EE, #D8D9EC)', borderRadius: '20px' }}>
                                <div style={{ display: "grid", gap: '20px', width: '32rem' }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <label className='form-label' style={{ width: '8rem' }}>Bin Series</label>
                                        <select
                                            className="form-select"
                                            name="BinSeries"
                                            value={formData.BinSeries}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">Select Bin Series</option>
                                            {Bin.map((item, index) => (
                                                <option key={index} value={item.series}>
                                                    {item.series}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <label className='form-label' style={{ width: '8rem' }}>Bin Number</label>
                                        <input type="text" className="form-select" name="Binnumber" value={formData.Binnumber} onChange={handleChange} required />
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '15px', gap: '10px' }}>
                                    <button type="submit" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "8rem", height: "2.5rem", background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', border: 'none', fontSize: '17px', gap: '4px' }}> <img src={submit} style={{ width: '1.2rem', fontSize: '15px' }} /> Submit</button>
                                    <button
                                        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: '#E63E23', border: 'none', fontSize: '17px', gap: '4px' }}
                                    ><img src={Cancel32} style={{ width: '1.2rem', fontSize: '15px' }} /> Cancel</button>
                                </div>
                            </div>
                            <div style={{backgroundColor:'#F1F1F1',borderRadius:'20px',padding:'10px'}}>
                                <h5 style={{ display: 'flex', background: 'linear-gradient(to bottom, #3b409e, #0067ab, #0f79ba, #0098d5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: '700', }}>Add Bin List</h5>
                                <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: '#e8f7f3', border: '1px solid #0067AB' }}>
                                    <table style={{ backgroundColor: '#e8f7f3', width: '100%' }}>
                                        <thead>
                                            <tr style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', height: '2.5rem' }}>
                                                <th>Sr.No</th>
                                                <th>Bin Name</th>
                                                <th>Max Qty</th>
                                                <th>Number</th>
                                                <th>Series</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.length === 0 ? (
                                                <tr>
                                                    <td colSpan="5" style={{ textAlign: 'center' }}>No data available</td>
                                                </tr>
                                            ) : (
                                                data.map((item, index) => (
                                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#E5F4FB' : '#CFE4F1' }}>
                                                        <td>{index+1}</td>
                                                        <td>{item.bin_name}</td>
                                                        <td>{item.bin_Max_quantity}</td>
                                                        <td>{item.number}</td>
                                                        <td>{item.series}</td>
                                                        <td style={{color:item.active_status === 'Active'? '#009245':'red',fontWeight:'bold'}}>{item.active_status}</td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default BinManagement;
